// extracted by mini-css-extract-plugin
export default {"companyText":"AddBook_companyText__+AxXA","book":"AddBook_book__5n3Bt","bookText":"AddBook_bookText__RCNKv","bookImage":"AddBook_bookImage__jFySx"};